import { subscriptionsItemComponent } from './subscriptions.item.component';
import {loadNg1Module, ngmodule} from "../../bootstrap/ngmodule";
import { subscriptionsDashboardItemState, subscriptionsDashboardState, subscriptionsState } from './subscriptions.states';
import { subscriptionsDashboardComponent } from "./subscriptions.dashboard.component";
import { subscriptionsComponent } from "./subscriptions.component";
import { isDay } from "../../filters/isDay.filter";


const subscriptionAppModule: aboTheme.INgModule = {
  components: { subscriptionsComponent, subscriptionsDashboardComponent, subscriptionsItemComponent },
  states: [ subscriptionsState, subscriptionsDashboardState, subscriptionsDashboardItemState ],
  filters: { isDay }
};

loadNg1Module(ngmodule, subscriptionAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/subscriptions/index.ts